import Typography from '@material-ui/core/Typography';
import React from 'react';
import { WithLink } from '../../utils/components.esm.js';
import { RadarDescription } from '../RadarDescription/RadarDescription.esm.js';

const RadarLegendLink = ({
  entryId,
  url,
  description,
  title,
  classes,
  active,
  links,
  timeline
}) => {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const toggle = () => {
    setOpen(!open);
  };
  if (description) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: "span",
        className: classes.entryLink,
        onClick: handleClickOpen,
        role: "button",
        tabIndex: 0,
        onKeyPress: toggle
      },
      /* @__PURE__ */ React.createElement(
        Typography,
        {
          component: "span",
          id: entryId,
          className: active ? classes.activeEntry : classes.entry
        },
        title
      )
    ), open && /* @__PURE__ */ React.createElement(
      RadarDescription,
      {
        open,
        onClose: handleClose,
        title: title ? title : "no title",
        url,
        description,
        timeline: timeline ? timeline : [],
        links
      }
    ));
  }
  return /* @__PURE__ */ React.createElement(WithLink, { url, className: classes.entryLink }, /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: "span",
      id: entryId,
      className: active ? classes.activeEntry : classes.entry
    },
    title
  ));
};

export { RadarLegendLink };
//# sourceMappingURL=RadarLegendLink.esm.js.map
